// NOTE: 現状PCのみで使用。将来的にSPもこちらのsliceを使用する
import { createSlice } from '@reduxjs/toolkit';

/**
 * 初期型
 */
export interface PlpLinkListDataIndexState {
  plpLinkListDataIndex: number;
}

// 初期状態
export const seoPlpLinkListDataIndexInitialState: PlpLinkListDataIndexState = {
  plpLinkListDataIndex: -1,
};

/**
 * seoPlpLinkListDataIndex Slice
 * @remarks PLP用の内部リンク表示対象状態かの判定用のフラグを保存
 */
export const seoPlpLinkListDataIndexSlice = createSlice({
  name: 'plpLinkList',
  initialState: seoPlpLinkListDataIndexInitialState,
  reducers: {
    setPlpLinkListDataIndex: (state, action) => {
      state.plpLinkListDataIndex = action.payload;
    },
  },
});

export const { setPlpLinkListDataIndex } = seoPlpLinkListDataIndexSlice.actions;

interface State {
  plpLinkList: PlpLinkListDataIndexState;
}

/**
 * selector
 * @param state
 */
export const appPlpLinkListDataIndexSelector = <S extends State>(state: S) =>
  state.plpLinkList.plpLinkListDataIndex;

// reducer
export const plpLinkListDataIndexReducer = seoPlpLinkListDataIndexSlice.reducer;

/**
 * selector
 * @param state
 */
export const plpLinkListDataIndexSelector = <S extends State>(state: S) =>
  state.plpLinkList.plpLinkListDataIndex;
